module.exports = __webpack_public_path__ + "img/LogoAnim.35d117c6.gif";